import React, { Fragment, useContext } from 'react';
import { timeDay, timeMinute } from 'd3-time';

import PresentationContext from '../PresentationContext';
import Stats from './Stats';
import { parseDate } from '../utils/formats';
import './Dashboard.css';

function InsulinStats(props) {
  const {
    basalEntries,
    bolusEntries,
    days,
    profiles = {},
    t,
    profileUseTimes,
    totalMinutes,
    profileChanges,
  } = props;

  const { formatDateString } = useContext(PresentationContext);
  const lastDay = days[days.length - 1];
  const tempBasals = basalEntries.filter(b => !isNaN(b.percent) || (b.id && (b.id.indexOf('tbr-') === 0)));

  return (
    <Stats id="stats" className="insulin stats">
      <h2>{t('insulin.stats.heading')}</h2>
      <dl>
        <dt>
          <time dateTime={days[0]}>{formatDateString(days[0])}</time>
          {
            days.length > 1
              ? (
                <Fragment>
                  <span> – </span>
                  <time dateTime={lastDay}>{formatDateString(lastDay)}</time>
                </Fragment>
              )
              : null
          }
        </dt>
        <dd>
          <time dateTime={`PD${days.length}`}>{t('insulin.stats.timeRange', {count: days.length})}</time>
        </dd>
      </dl>
      <table>
        <caption></caption>
        <thead>
          <tr>
            <th><span>{t('insulin.stats.entries.heading')}</span></th>
            <th>{t('insulin.stats.entries.daily')} <small>{t('insulin.stats.entries.avg')}</small></th>
            <th>{t('insulin.stats.entries.total')}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th><span>{t('insulin.stats.entries.basalDoses')}</span></th>
            <td><span>{(basalEntries.length / days.length).toFixed(0)}</span></td>
            <td><span>{basalEntries.length}</span></td>
          </tr>
          <tr>
            <th><span>{t('insulin.stats.entries.basalProfileChanges')}</span></th>
            <td><span>{(profileChanges.length / days.length).toFixed(0)}</span></td>
            <td><span>{profileChanges.length}</span></td>
          </tr>
          <tr>
            <th><span>{t('insulin.stats.entries.tempBasalSettings')}</span></th>
            <td><span>{(tempBasals.length / days.length).toFixed(0)}</span></td>
            <td><span>{tempBasals.length}</span></td>
          </tr>
          <tr>
            <th><span>{t('insulin.stats.entries.bolus')}</span></th>
            <td><span>{(bolusEntries.length / days.length).toFixed(0)}</span></td>
            <td><span>{bolusEntries.length}</span></td>
          </tr>
        </tbody>
      </table>

      <table>
        <caption></caption>
        <thead>
          <tr>
            <th><span>{t('insulin.stats.profiles.heading')}</span></th>
            <th>{t('insulin.stats.profiles.timeInUse')}</th>
          </tr>
        </thead>
        <tbody>
          {Object.values(profiles).map((p, i) => (
            <tr key={p.id}>
              <th><span>{p.name}</span></th>
              <td><span>{`${(profileUseTimes[Object.keys(profileUseTimes)[i]] / totalMinutes * 100).toFixed(1)} %`} (<time dateTime={`PD${days.length}`}>{t('insulin.stats.timeRange', {count: days.length})}</time>)</span></td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* 
      <dl>
        <dt>Basal profiles in use</dt>
        <dd>1</dd>
      </dl>

      <dl>
        <dt>Average basal</dt>
        <dd>{unitFormat(dailyMeans.basal)} ± {unitFormat(dailyDeviations.basal)} iu</dd>
        <dt>Average bolus</dt>
        <dd>{unitFormat(dailyMeans.bolus)} ± {unitFormat(dailyDeviations.bolus)} iu</dd>
        <dt>Average daily total</dt>
        <dd>{unitFormat(dailyMeans.total)} ± {unitFormat(dailyDeviations.total)} iu</dd>
      </dl>
      
      
      
      TODO:
        What to do with incomplete days? Just ignore? Truncate to proportional? Safest to just ignore...
        How many boluses per day, min & max?
        How many temp basals per day, min & max?

        Visualize all basal profiles available and in use
        How much and when a profile has been used? Also in calendar view?
      */}
    </Stats>
  );
}

export default InsulinStats;
